import { noop } from 'lodash';
import { createContext } from 'react';
export const ModalQueueContext = createContext({
    queue: [],
    setOpen: noop,
});
//# sourceMappingURL=context.js.map